import React, { useEffect, useState } from 'react'
import moment from 'moment'
import './Deenergized.css'
import { oktmo2name, code2region } from './Utils'
import Graph from './Graph'

import { Button } from 'primereact/button'

export default function Deenergized(props) {
	
	const { ENV, DS, visibleAlerts, region } = props
	
	const [total, setTotal] = useState([])
	const [minDatetime, setMinDatetime] = useState(moment())
	const [maxDatetime, setMaxDatetime] = useState(moment())
	
	useEffect(() => {
		let _total = []
		DS.data.deenergized.forEach(e => {
			let _head = _total.find(el => el.head === e.head_company)
			if (_head === undefined) {
				_head = {
					head: e.head_company,
					sum: 0
				}
				_total.push(_head)
			}
			_head.sum += +e.population
		})
		_total.sort((a, b) => b.sum - a.sum)
		setTotal(_total)
		//DS.userSettings.visiblePoweroff.forEach(reg => DS.loadPoweroff(reg))
	}, [DS.data.deenergized])
	
	useEffect(() => {
		if (DS.userSettings.visiblePoweroff.length > 0) {
			const _minDatetime = moment.min(DS.userSettings.visiblePoweroff.map(e => DS.data.poweroff[e]?.datasets[0].data[0].x).filter(e => e))
			if (!_minDatetime.isSame(minDatetime)) setMinDatetime(_minDatetime)
		} else setMinDatetime(moment())
	}, [DS.userSettings.visiblePoweroff])
	
	useEffect(() => {
		setMaxDatetime(moment())
	}, [DS.data.deenergized, DS.userSettings.visiblePoweroff])
	
	const logo = (name) => 
		name === 'Россети' ? 'rosseti' :
		name === 'Русгидро' ? 'rushydro' :
		name === 'БЭСК' ? 'besk' :
		name === 'СУЭНКО' ? 'suenco' :
		name === 'АО «Алтайкрайэнерго»' ? 'altay' :
		name === 'АО «РЭС»' ? 'eseti' :
		name === 'АО «НЭСК-электросети»' ? 'nesk' :
		name === 'АО «Электросети Кубани»' ? 'nesk2' :
		name === 'ИЭСК' ? 'iesk' :
		name === 'АО «Сетевая компания»' ? 'tatsk' :
		name === 'АО «Мособлэнерго»' ? 'mosobl' :
		name === 'АО «ЛОЭСК»' ? 'loesk' :
		name === 'ООО «Севастопольэнерго»' ? 'seven' :
		name === 'ГУП РК «Крымэнерго»' ? 'crymen' :
		name === 'АО «Донэнерго»' ? 'donen' :
		name === 'АО ВОЭ' ? 'voel' :
		'default'
	
	const toggleGraph = (code) => {
		if (DS.userSettings.visiblePoweroff.includes(code))
			DS.setters.setVisiblePoweroff(DS.userSettings.visiblePoweroff.filter(e => e !== code))
		else {
			DS.setters.setVisiblePoweroff([...DS.userSettings.visiblePoweroff, code])
			DS.loadPoweroff(code)
		}
	}
	
	const centerMapTo = (reg) => {
		//console.log('center map to:', reg)
	}
	
	const max = (reg) => {
		return DS.data.poweroff[reg]?.datasets[0].data.reduce((a, e) => Math.max(a, e.y), 0)
	}
	
	useEffect(() => {
		if (region !== 'all') DS.loadPoweroff(region)
	}, [region])
	
	return <div className="info col pr-3">
		<div className="deenergized-counters-header">
			{region === 'all' && total.map((e, i) => <div key={i} className="company-counter">
				<img src={'/images/logo_' + logo(e.head) + '.png'} title={e.head} />
				<span>{e.sum}</span>
			</div>)}
		</div>
		<table className="deenergized">
			<tbody>
				{DS.data.deenergized.filter(e => region === 'all' || region === e.region_code).sort((a, b) => b.population - a.population).map((e, i) => 
					region !== 'all' || DS.userSettings.visiblePoweroff.includes(e.region_code)
						? <React.Fragment key={i}>
							<tr className={e.population > 5000 ? 'red-alert' : e.population > 2000 ? 'yellow-alert' : ''}>
								<td rowSpan={3}>{oktmo2name[code2region[e.region_code].oktmo]}</td>
								<td className="text-right p-0"><Button className="p-button-sm" icon="pi pi-times" rounded text severity="secondary"  onClick={() => toggleGraph(e.region_code)}/></td>
								<td className={'logo ' + logo(e.head_company)}></td>
								<td className="company">{e.company}</td>
							</tr>
							<tr className={'--collapse-- ' + (e.population > 5000 ? 'red-alert' : e.population > 2000 ? 'yellow-alert' : '')}>
								<td className="text-right val-max">макс {max(e.region_code)}</td>
								<td colSpan={2} rowSpan={2} className="graph">
									<Graph data={DS.data.poweroff[e.region_code]} minDatetime={minDatetime} maxDatetime={maxDatetime} />
								</td>
							</tr>
							<tr className={'--collapse-- ' + (e.population > 5000 ? 'red-alert' : e.population > 2000 ? 'yellow-alert' : '')}>
								<td className="text-right val-current">тек {e.population}</td>
							</tr>
						</React.Fragment>
						: <React.Fragment key={i}>
							<tr className={e.population > 5000 ? 'red-alert' : e.population > 2000 ? 'yellow-alert' : ''}>
								<td>{oktmo2name[code2region[e.region_code].oktmo]}</td>
								<td className={'text-right' + (region === 'all' ? ' clickable' : '')} onClick={() => region === 'all' && toggleGraph(e.region_code)}>{e.population}</td>
								<td className={'logo ' + logo(e.head_company)}></td>
								<td className="company">{e.company}</td>
							</tr>
						</React.Fragment>
				)}
			</tbody>
		</table>
	</div>
	
}

